// extracted by mini-css-extract-plugin
export var p2 = "index-module--p2--rJr3g";
export var p3 = "index-module--p3--1ZmlS";